<script lang="ts" setup>
    import { AVAILABLE_LOCALES } from '@/translations/i18n';
    import { useI18n } from 'vue-i18n';
    import type { TLocale } from '@/translations/i18n';

    const { locale } = useI18n();

    function toggleLocale() {
        const index = AVAILABLE_LOCALES.indexOf(locale.value as TLocale);
        locale.value = AVAILABLE_LOCALES[(index + 1) % AVAILABLE_LOCALES.length];
    }
</script>

<template>
    <button
        class="hover:border-primary flex items-center gap-1 rounded border border-gray-200 px-2 py-1 text-xs font-semibold"
        data-test="locale-toggle"
        @click="toggleLocale"
    >
        <span :class="locale === 'fr_Fr' ? 'text-primary' : 'text-gray-400'">FR</span>
        <span class="text-gray-300">|</span>
        <span :class="locale === 'en_En' ? 'text-primary' : 'text-gray-400'">EN</span>
    </button>
</template>
